module.exports = __webpack_public_path__ + "img/gear-violet.6e68f5a9.svg";